import React from 'react'
import moment from 'moment'
import { Switch, Tooltip, Modal, message } from 'antd'
import { Link } from 'react-router-dom'

function ProductionStageRow(props) {
    const { item, reload } = props
    const { _id, name, partner, created, updated, status, } = { ...item }

    const { name: partnerName } = { ...partner }


    const _handleDelete = async (id) => {
        try {
            // const res = await deletePackageIssue(id)

            // const { message: mess, success } = res
            // if (!success) {
            //     throw new Error(mess)
            // }
            message.success('Deleted successfully!')
            reload()
        } catch (e) {
            message.error(e.message || 'Unknown error.')
        }
    }

    const handleClickDelete = (e, id) => {
        e.preventDefault()
        Modal.confirm({
            title: <span className='text-danger fs-14'>Confirm Delete</span>,
            icon: '',
            content: 'Are you sure you want to delete?',
            okText: 'Ok',
            cancelText: 'Cancel',
            onOk: () => _handleDelete(id)
        })

    }

    return (
        <tr>
            <td>{name}</td>
            {/* <td>Key</td> */}
            <td>{partnerName}</td>
            {/* <td>
                <Switch onClick={() => handleChangeStatus()} />
            </td> */}
            <td>{created ? moment(created).format('HH:mm DD/MM/YYYY') : ''}</td>
            <td>{updated ? moment(updated).format('HH:mm DD/MM/YYYY') : ''}</td>
            <td>
                <Tooltip title='Chỉnh sửa'>
                    <Link to={`/production-stage/${_id}`}><i className="icon-pencil text-primary mx-1" /></Link>
                </Tooltip>
                {/* <Tooltip title='Delete'>
                    <span className="text-danger mx-1 cursor-pointer"
                        onClick={(e) => handleClickDelete(e, _id)}
                    >
                        <i className="icon-bin text-danger mx-1" />
                    </span>
                </Tooltip> */}
            </td>
        </tr>
    )
}

export default ProductionStageRow